import { Typography } from 'components';
import React from 'react';
import styled from 'styled-components';
import theme from 'themes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const GearIcon = styled.div`
  width: 9.3rem;
  position: relative;
  margin-top: 3rem;
  margin-bottom: 1.5rem;
`;
const TextContent = styled.div``;
const CircleIcon = styled.span`
  position: absolute;
  bottom: -1.5rem;
  right: 0.3rem;
`;

export const DataNotFound = ({ textMsg }: { textMsg?: string }): JSX.Element => {
  return (
    <Container>
      <GearIcon className='gear-icon' style={{ position: 'relative' }}>
        <svg
          width="121"
          height="120"
          viewBox="0 0 121 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Union">
            <g id="depth" style={{ mixBlendMode: 'multiply' }} filter="url(#filter0_dd_6713_454)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.2535 2.99995C54.2535 1.89538 55.149 0.999947 56.2535 0.999947H65.9545C67.059 0.999947 67.9545 1.89538 67.9545 2.99995V8.06426C67.9545 9.05097 68.6753 9.88568 69.6443 10.0715C76.1973 11.328 82.2716 13.931 87.5684 17.5816C88.3855 18.1447 89.4931 18.0676 90.1949 17.3659L94.1859 13.3749C94.9669 12.5939 96.2332 12.5939 97.0143 13.3749L103.874 20.2346C104.655 21.0156 104.655 22.282 103.874 23.063L99.904 27.0329C99.2004 27.7366 99.125 28.8478 99.6924 29.6652C103.39 34.9926 106.026 41.1131 107.293 47.72C107.479 48.6891 108.313 49.4099 109.3 49.4099H114.364C115.469 49.4099 116.364 50.3053 116.364 51.4099V61.1108C116.364 62.2154 115.469 63.1108 114.364 63.1108H109.466C108.465 63.1108 107.622 63.8527 107.452 64.8397C106.261 71.7541 103.574 78.1569 99.7377 83.7036C99.1724 84.5209 99.2487 85.6304 99.9514 86.333L102.961 89.3424C103.742 90.1235 103.742 91.3898 102.961 92.1709L96.1011 99.0305C95.3201 99.8116 94.0537 99.8116 93.2727 99.0305L90.2633 96.0212C89.5606 95.3185 88.4511 95.2422 87.6339 95.8075C82.3218 99.4818 76.2243 102.101 69.6444 103.363C68.6753 103.548 67.9545 104.383 67.9545 105.37V110.434C67.9545 111.539 67.059 112.434 65.9545 112.434H56.2535C55.149 112.434 54.2535 111.539 54.2535 110.434V105.536C54.2535 104.534 53.5116 103.692 52.5247 103.522C45.5966 102.328 39.1822 99.6334 33.6279 95.7848C32.8105 95.2184 31.7002 95.2943 30.997 95.9975L27.9064 99.0881C27.1254 99.8691 25.859 99.8691 25.078 99.0881L18.2183 92.2284C17.4373 91.4474 17.4373 90.181 18.2183 89.4L21.3195 86.2988C22.0218 85.5965 22.0985 84.488 21.5342 83.6708C17.7098 78.1317 15.0316 71.7404 13.8425 64.8397C13.6724 63.8527 12.8299 63.1108 11.8284 63.1108H6.93018C5.82561 63.1108 4.93018 62.2154 4.93018 61.1108V51.4099C4.93018 50.3053 5.82561 49.4099 6.93018 49.4099H11.9945C12.9812 49.4099 13.8159 48.6891 14.0017 47.72C15.2838 41.0332 17.968 34.8447 21.7364 29.4725C22.3101 28.6547 22.2371 27.5381 21.5308 26.8317L17.8196 23.1205C17.0385 22.3395 17.0385 21.0732 17.8196 20.2921L24.6793 13.4324C25.4603 12.6514 26.7266 12.6514 27.5077 13.4324L31.302 17.2268C32.001 17.9258 33.1033 18.0053 33.92 17.4484C39.4066 13.7069 45.7179 11.0853 52.5247 9.91226C53.5117 9.74219 54.2535 8.89969 54.2535 7.8982V2.99995ZM60.6473 89.5993C78.8077 89.5993 93.5295 74.8775 93.5295 56.7171C93.5295 38.5566 78.8077 23.8348 60.6473 23.8348C42.4869 23.8348 27.7651 38.5566 27.7651 56.7171C27.7651 74.8775 42.4869 89.5993 60.6473 89.5993Z"
                fill="white"
              />
            </g>
            <g id="background" filter="url(#filter1_b_6713_454)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.2535 2.99995C54.2535 1.89538 55.149 0.999947 56.2535 0.999947H65.9545C67.059 0.999947 67.9545 1.89538 67.9545 2.99995V8.06426C67.9545 9.05097 68.6753 9.88568 69.6443 10.0715C76.1973 11.328 82.2716 13.931 87.5684 17.5816C88.3855 18.1447 89.4931 18.0676 90.1949 17.3659L94.1859 13.3749C94.9669 12.5939 96.2332 12.5939 97.0143 13.3749L103.874 20.2346C104.655 21.0156 104.655 22.282 103.874 23.063L99.904 27.0329C99.2004 27.7366 99.125 28.8478 99.6924 29.6652C103.39 34.9926 106.026 41.1131 107.293 47.72C107.479 48.6891 108.313 49.4099 109.3 49.4099H114.364C115.469 49.4099 116.364 50.3053 116.364 51.4099V61.1108C116.364 62.2154 115.469 63.1108 114.364 63.1108H109.466C108.465 63.1108 107.622 63.8527 107.452 64.8397C106.261 71.7541 103.574 78.1569 99.7377 83.7036C99.1724 84.5209 99.2487 85.6304 99.9514 86.333L102.961 89.3424C103.742 90.1235 103.742 91.3898 102.961 92.1709L96.1011 99.0305C95.3201 99.8116 94.0537 99.8116 93.2727 99.0305L90.2633 96.0212C89.5606 95.3185 88.4511 95.2422 87.6339 95.8075C82.3218 99.4818 76.2243 102.101 69.6444 103.363C68.6753 103.548 67.9545 104.383 67.9545 105.37V110.434C67.9545 111.539 67.059 112.434 65.9545 112.434H56.2535C55.149 112.434 54.2535 111.539 54.2535 110.434V105.536C54.2535 104.534 53.5116 103.692 52.5247 103.522C45.5966 102.328 39.1822 99.6334 33.6279 95.7848C32.8105 95.2184 31.7002 95.2943 30.997 95.9975L27.9064 99.0881C27.1254 99.8691 25.859 99.8691 25.078 99.0881L18.2183 92.2284C17.4373 91.4474 17.4373 90.181 18.2183 89.4L21.3195 86.2988C22.0218 85.5965 22.0985 84.488 21.5342 83.6708C17.7098 78.1317 15.0316 71.7404 13.8425 64.8397C13.6724 63.8527 12.8299 63.1108 11.8284 63.1108H6.93018C5.82561 63.1108 4.93018 62.2154 4.93018 61.1108V51.4099C4.93018 50.3053 5.82561 49.4099 6.93018 49.4099H11.9945C12.9812 49.4099 13.8159 48.6891 14.0017 47.72C15.2838 41.0332 17.968 34.8447 21.7364 29.4725C22.3101 28.6547 22.2371 27.5381 21.5308 26.8317L17.8196 23.1205C17.0385 22.3395 17.0385 21.0732 17.8196 20.2921L24.6793 13.4324C25.4603 12.6514 26.7266 12.6514 27.5077 13.4324L31.302 17.2268C32.001 17.9258 33.1033 18.0053 33.92 17.4484C39.4066 13.7069 45.7179 11.0853 52.5247 9.91226C53.5117 9.74219 54.2535 8.89969 54.2535 7.8982V2.99995ZM60.6473 89.5993C78.8077 89.5993 93.5295 74.8775 93.5295 56.7171C93.5295 38.5566 78.8077 23.8348 60.6473 23.8348C42.4869 23.8348 27.7651 38.5566 27.7651 56.7171C27.7651 74.8775 42.4869 89.5993 60.6473 89.5993Z"
                fill="#0076CC"
              />
            </g>
            <g
              id="overlay"
              style={{ mixBlendMode: 'hard-light' }}
              filter="url(#filter2_ii_6713_454)"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.2535 2.99995C54.2535 1.89538 55.149 0.999947 56.2535 0.999947H65.9545C67.059 0.999947 67.9545 1.89538 67.9545 2.99995V8.06426C67.9545 9.05097 68.6753 9.88568 69.6443 10.0715C76.1973 11.328 82.2716 13.931 87.5684 17.5816C88.3855 18.1447 89.4931 18.0676 90.1949 17.3659L94.1859 13.3749C94.9669 12.5939 96.2332 12.5939 97.0143 13.3749L103.874 20.2346C104.655 21.0156 104.655 22.282 103.874 23.063L99.904 27.0329C99.2004 27.7366 99.125 28.8478 99.6924 29.6652C103.39 34.9926 106.026 41.1131 107.293 47.72C107.479 48.6891 108.313 49.4099 109.3 49.4099H114.364C115.469 49.4099 116.364 50.3053 116.364 51.4099V61.1108C116.364 62.2154 115.469 63.1108 114.364 63.1108H109.466C108.465 63.1108 107.622 63.8527 107.452 64.8397C106.261 71.7541 103.574 78.1569 99.7377 83.7036C99.1724 84.5209 99.2487 85.6304 99.9514 86.333L102.961 89.3424C103.742 90.1235 103.742 91.3898 102.961 92.1709L96.1011 99.0305C95.3201 99.8116 94.0537 99.8116 93.2727 99.0305L90.2633 96.0212C89.5606 95.3185 88.4511 95.2422 87.6339 95.8075C82.3218 99.4818 76.2243 102.101 69.6444 103.363C68.6753 103.548 67.9545 104.383 67.9545 105.37V110.434C67.9545 111.539 67.059 112.434 65.9545 112.434H56.2535C55.149 112.434 54.2535 111.539 54.2535 110.434V105.536C54.2535 104.534 53.5116 103.692 52.5247 103.522C45.5966 102.328 39.1822 99.6334 33.6279 95.7848C32.8105 95.2184 31.7002 95.2943 30.997 95.9975L27.9064 99.0881C27.1254 99.8691 25.859 99.8691 25.078 99.0881L18.2183 92.2284C17.4373 91.4474 17.4373 90.181 18.2183 89.4L21.3195 86.2988C22.0218 85.5965 22.0985 84.488 21.5342 83.6708C17.7098 78.1317 15.0316 71.7404 13.8425 64.8397C13.6724 63.8527 12.8299 63.1108 11.8284 63.1108H6.93018C5.82561 63.1108 4.93018 62.2154 4.93018 61.1108V51.4099C4.93018 50.3053 5.82561 49.4099 6.93018 49.4099H11.9945C12.9812 49.4099 13.8159 48.6891 14.0017 47.72C15.2838 41.0332 17.968 34.8447 21.7364 29.4725C22.3101 28.6547 22.2371 27.5381 21.5308 26.8317L17.8196 23.1205C17.0385 22.3395 17.0385 21.0732 17.8196 20.2921L24.6793 13.4324C25.4603 12.6514 26.7266 12.6514 27.5077 13.4324L31.302 17.2268C32.001 17.9258 33.1033 18.0053 33.92 17.4484C39.4066 13.7069 45.7179 11.0853 52.5247 9.91226C53.5117 9.74219 54.2535 8.89969 54.2535 7.8982V2.99995ZM60.6473 89.5993C78.8077 89.5993 93.5295 74.8775 93.5295 56.7171C93.5295 38.5566 78.8077 23.8348 60.6473 23.8348C42.4869 23.8348 27.7651 38.5566 27.7651 56.7171C27.7651 74.8775 42.4869 89.5993 60.6473 89.5993Z"
                fill="#A3A3A3"
              />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_dd_6713_454"
              x="0.930176"
              y="-5.34058e-05"
              width="119.434"
              height="119.434"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="1.5" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_6713_454"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="3" />
              <feGaussianBlur stdDeviation="2" />
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
              <feBlend
                mode="normal"
                in2="effect1_dropShadow_6713_454"
                result="effect2_dropShadow_6713_454"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect2_dropShadow_6713_454"
                result="shape"
              />
            </filter>
            <filter
              id="filter1_b_6713_454"
              x="2.93018"
              y="-1.00005"
              width="115.434"
              height="115.434"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
              <feComposite
                in2="SourceAlpha"
                operator="in"
                result="effect1_backgroundBlur_6713_454"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_backgroundBlur_6713_454"
                result="shape"
              />
            </filter>
            <filter
              id="filter2_ii_6713_454"
              x="4.93018"
              y="0.999947"
              width="111.434"
              height="111.434"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1" />
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.196112 0 0 0 0 0.628811 0 0 0 0 0.960547 0 0 0 1 0"
              />
              <feBlend mode="normal" in2="shape" result="effect1_innerShadow_6713_454" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="5" />
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0.480026 0 0 0 0 0.848047 0 0 0 1 0"
              />
              <feBlend
                mode="normal"
                in2="effect1_innerShadow_6713_454"
                result="effect2_innerShadow_6713_454"
              />
            </filter>
          </defs>
        </svg>
        <CircleIcon>
          <svg
            width="84"
            height="83"
            viewBox="0 0 84 83"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Group 59521" filter="url(#filter0_d_6713_459)">
              <g id="Ellipse 2">
                <g id="background" filter="url(#filter1_b_6713_459)">
                  <path
                    d="M79.3487 37.4651C79.3487 58.0922 62.6271 74.8139 41.9999 74.8139C21.3728 74.8139 4.65112 58.0922 4.65112 37.4651C4.65112 16.8379 21.3728 0.116272 41.9999 0.116272C62.6271 0.116272 79.3487 16.8379 79.3487 37.4651ZM18.8096 37.4651C18.8096 50.2728 29.1922 60.6554 41.9999 60.6554C54.8076 60.6554 65.1903 50.2728 65.1903 37.4651C65.1903 24.6574 54.8076 14.2747 41.9999 14.2747C29.1922 14.2747 18.8096 24.6574 18.8096 37.4651Z"
                    fill="#0076CC"
                  />
                </g>
                <path
                  id="overlay"
                  d="M78.2369 46.5102C79.6311 40.9247 79.7152 35.0925 78.4827 29.4691C77.2503 23.8457 74.7345 18.5833 71.132 14.0929C67.5294 9.60255 62.9376 6.00576 57.7151 3.58344C52.4927 1.16112 46.7809 -0.0211442 41.026 0.128972L41.394 14.2361C44.9745 14.1427 48.5281 14.8783 51.7773 16.3853C55.0265 17.8924 57.8833 20.1302 60.1247 22.9239C62.366 25.7176 63.9312 28.9916 64.698 32.4903C65.4648 35.9889 65.4125 39.6175 64.5451 43.0926L78.2369 46.5102Z"
                  fill="#004577"
                />
              </g>
            </g>
            <defs>
              <filter
                id="filter0_d_6713_459"
                x="0.651123"
                y="0.116272"
                width="82.6976"
                height="82.6976"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_6713_459"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_6713_459"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_b_6713_459"
                x="2.65112"
                y="-1.88373"
                width="78.6976"
                height="78.6976"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="1" />
                <feComposite
                  in2="SourceAlpha"
                  operator="in"
                  result="effect1_backgroundBlur_6713_459"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_backgroundBlur_6713_459"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </CircleIcon>
      </GearIcon>
      <TextContent>
        <Typography variant="h5" className='data-not-found-text' color={theme.colors.lightGrey8}>
          {textMsg}
        </Typography>
      </TextContent>
    </Container>
  );
};
